/* eslint-disable react/prop-types */
import { IconButton, InputAdornment, TextField } from '@mui/material'
import { Close, Search } from '@mui/icons-material'
import { useCallback, useEffect, useState } from 'react'
import { useQualityNumberFilters } from 'hooks/useQualityNumberFilters'
import useDebounce from 'hooks/useDebounce'

/**
 * Renders a search field component for selecting multiple events and conversions.
 *
 * @param {Object} props - The component props.
 * @param {boolean} props.loading - Indicates whether the options are currently loading.
 * @returns {JSX.Element} A React component representing the search field.
 */
function SearchField({ loading }) {
  const { filters, setInputSearch, unsetInputSearch } = useQualityNumberFilters()
  const [inputValue, setInputValue] = useState(() => {
    if (filters?.search) return filters.search
    return ''
  })

  const debouncedValue = useDebounce(inputValue, 600)

  const handleInputChange = useCallback((event) => {
    const { value } = event.target
    const allowed = /[^0-9a-zA-Z_-\s]/gi
    const formatedValue = value?.replace(allowed, '')
    setInputValue(formatedValue)
  }, [])

  useEffect(() => {
    if (debouncedValue) {
      setInputSearch(debouncedValue)
    } else if (filters?.search) {
      unsetInputSearch()
    }
  }, [debouncedValue, filters?.search, setInputSearch, unsetInputSearch])

  return (
    <TextField
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search color="action" />
          </InputAdornment>
        ),
        endAdornment: inputValue ? (
          <IconButton onClick={() => setInputValue('')} aria-label="Clear input">
            <Close color="#f00" />
          </IconButton>
        ) : null,
      }}
      data-testid="search-field-input"
      placeholder="Buscar por número de telefone ou nome"
      onChange={handleInputChange}
      value={inputValue}
      disabled={loading}
      fullWidth
      sx={(theme) => ({
        borderRadius: 1,
        '& .HiTheme-OutlinedInput-notchedOutline': {
          border: 'none',
          bgcolor: theme.palette.colors.inputSearchBg,
        },
      })}
      helperText="Para pesquisar um telefone, informe apenas números sem traços ou caracteres especiais."
    />
  )
}

export default SearchField
